import { Fragment, memo } from "react";
import {
  XMarkIcon,
  CheckIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { classNames } from "../tools/ClassNames";

const statuses = {
  Pagada: {
    Color: "text-green-600 bg-green-100 ring-green-400/10",
    Texto: "text-green-400",
    IconoS: CheckIcon,
  },
  Pendiente: {
    Color: "text-yellow-700 bg-yellow-100 ring-yellow-400/10",
    Texto: "text-yellow-400",
    IconoS: ExclamationTriangleIcon,
  },
  Vencida: {
    Color: "text-red-700 bg-red-100 ring-red-400/10",
    Texto: "text-red-400",
    IconoS: XMarkIcon,
  },
};

const PagosRecientesAlumnos = ({ datos = [], title = "" }) => {
  return (
    <div className="space-y-16 py-2 xl:space-y-20 bg-primarioMira rounded-md shadow-md shadow-primarioMira">
      <div>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="mx-auto max-w-2xl text-lg font-semibold leading-6 text-white lg:mx-0 lg:max-w-none">
            {title}
          </h2>
        </div>
        <div className="mt-6  overflow-scroll md:overflow-hidden border-t border-gray-100">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
              <table className="w-full text-left">
                <tbody>
                  {/* {rawDataCta?.map((pago) => ( */}
                  <Fragment key={"Últimas 3 colegiaturas"}>
                    <tr className="text-sm leading-6 text-white">
                      <th
                        scope="colgroup"
                        colSpan={3}
                        className="relative isolate py-2 font-semibold"
                      >
                        <div>Últimas 3 colegiaturas</div>
                        <div className="absolute inset-y-0 right-full -z-10 w-screen border-b border-grisMira bg-secundarioMira" />
                        <div className="absolute inset-y-0 left-0 -z-10 w-screen border-b border-grisMira bg-secundarioMira" />
                      </th>
                    </tr>
                    {/* {datos.length > 0 && */}
                    {datos?.Detalle?.map((detail) => {
                      let IconoS = statuses[detail?.estado]?.IconoS;
                      //console.log("detail", detail);
                      return (
                        <tr key={detail?.cargo}>
                          <td className="relative py-5 pr-6">
                            <div className="flex gap-x-6">
                              <IconoS
                                className={classNames(
                                  statuses[detail?.estado]?.Texto,
                                  "hidden h-6 w-5 flex-none sm:block",
                                )}
                                aria-hidden="true"
                              />
                              <div className="flex-auto">
                                <div className="flex items-start gap-x-3">
                                  <div className="text-base font-medium leading-6 text-white">
                                    {Intl.NumberFormat("es-GT", {
                                      style: "currency",
                                      currency: "GTQ",
                                    }).format(detail?.valor)}
                                  </div>
                                  <div
                                    className={classNames(
                                      statuses[detail?.estado]?.Color,
                                      "rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset",
                                    )}
                                  >
                                    {detail?.estado}
                                  </div>
                                </div>
                                <div className="mt-1 text-sm leading-5 text-grisMira">
                                  Fecha de vencimiento {detail?.FechaVence}
                                </div>
                              </div>
                            </div>
                            <div className="absolute bottom-0 right-full h-px w-screen bg-gray-100" />
                            <div className="absolute bottom-0 left-0 h-px w-screen bg-gray-100" />
                          </td>
                          <td className="hidden py-5 pr-6 sm:table-cell">
                            <div className="text-base leading-6 text-white">
                              {detail?.cargo}
                            </div>
                            <div className="mt-1 text-sm leading-5 text-grisMira">
                              Días vencidos {detail?.DVence}
                            </div>
                          </td>

                          {detail?.Iddoc !== "" && (
                            <td className="py-5 text-right">
                              <div className="flex justify-end">
                                {detail?.pathCompleto !== "#" && (
                                  <a
                                    href={detail?.pathCompleto}
                                    target="_blank"
                                    className="text-base font-medium text-azulBrillanteMira hover:text-azulLogos hover:underline"
                                    rel="noreferrer"
                                  >
                                    Ver más
                                  </a>
                                )}
                              </div>
                              <div className="mt-1 text-sm leading-5 text-grisMira">
                                Documento{" "}
                                <span className="text-grisMira">
                                  #{detail?.Iddoc}
                                </span>
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </Fragment>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(PagosRecientesAlumnos);

